var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7520_3207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 19.206C20.0023 19.5927 19.9214 19.9753 19.7629 20.3287C19.6045 20.682 19.3722 20.9979 19.0813 21.2554C18.7904 21.513 18.4477 21.7063 18.0757 21.8225C17.7038 21.9388 17.3112 21.9753 16.924 21.9297C15.5143 21.7229 14.4813 20.5066 14.5157 19.0941V2.85412C14.4816 1.44007 15.5172 0.223102 16.9287 0.0185175C17.3156 -0.0264058 17.7077 0.0106331 18.079 0.127184C18.4504 0.243735 18.7926 0.437142 19.0829 0.694612C19.3733 0.952081 19.6052 1.26775 19.7633 1.62072C19.9215 1.9737 20.0022 2.35595 20.0002 2.74218V19.206Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.74227 16.5149C4.2568 16.5149 5.48453 17.7324 5.48453 19.234C5.48453 20.7358 4.2568 21.9531 2.74227 21.9531C1.22773 21.9531 0 20.7358 0 19.2341C0 17.7324 1.22773 16.5149 2.74227 16.5149ZM9.95773 8.27369C8.43609 8.35642 7.25539 9.62204 7.29078 11.1328V18.4365C7.29078 20.4187 8.17039 21.622 9.45914 21.8785C9.85869 21.9588 10.2713 21.95 10.6669 21.8525C11.0626 21.7551 11.4314 21.5716 11.7467 21.3153C12.0619 21.059 12.3157 20.7363 12.4895 20.3706C12.6634 20.005 12.753 19.6056 12.7518 19.2013V11.0069C12.7525 10.6446 12.6804 10.2858 12.5398 9.95149C12.3991 9.61714 12.1927 9.31391 11.9326 9.0595C11.6726 8.80508 11.364 8.60457 11.0249 8.46967C10.6858 8.33476 10.323 8.26809 9.95773 8.27369Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7520_3207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGAnalytics);
export default __webpack_public_path__ + "static/media/g_analytics.25f1e59ded067784ab9da13058fbb093.svg";
export { ForwardRef as ReactComponent };